var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark11Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.97,
    height: 11.153,
    viewBox: "0 0 10.97 11.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M10.208,17.085,6.175,13.052a.907.907,0,1,1,1.283-1.283l2.383,2.383,5.316-7.791a.928.928,0,0,1,1.558,1.008Z",
    transform: "translate(-5.9 -5.931)",
    fill: "#111"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark11Px);
export default __webpack_public_path__ + "static/media/checkmark-11px.b3271817.svg";
export { ForwardRef as ReactComponent };